<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >

    <v-row justify="center">
      <v-col
        cols="12"
        md="7"
      >
        <base-material-card style=" margin: 0px">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Информация о госте
            </div>
          </template>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    label="Имя"
                    v-model="reservationInfo.firstName"
                    :error-messages="errors['firstName'] || []"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field label="Фамилия"
                                v-model="reservationInfo.lastName"
                                :error-messages="errors['lastName'] || []"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    label="Телефон"
                    v-model="reservationInfo.phone"
                    :error-messages="errors['phone'] || []"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field label="Email"
                                v-model="reservationInfo.email"
                                :error-messages="errors['email'] || []"
                                required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    v-model="reservationInfo.notes"
                    :error-messages="errors['notes'] || []"
                    height="20px"
                    label="Комментарий"
                  ></v-textarea>
                </v-col>
                <v-col>
                  <v-simple-table v-if="guests.length">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-left">Id</th>
                        <th class="text-left">FirstName</th>
                        <th class="text-left">LastNAme</th>
                        <th class="text-left">Phone</th>
                        <th class="text-left">Email</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="guest in guests" :key="guest.id" style="cursor: pointer" @click="setGuest(guest)">
                        <td>{{ guest.id }}</td>
                        <td>{{ guest.first_name }}</td>
                        <td>{{ guest.last_name }}</td>
                        <td>{{ guest.phone }}</td>
                        <td>{{ guest.email }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <base-material-card style=" margin: 0px">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Информация о резерве
            </div>
          </template>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field @click="openPicker" label="Дата визита" v-model="reservationInfo.dateVisit" readonly
                                required></v-text-field>
                  <datepicker ref="programaticOpen" :disabled-dates="disabledDates"
                              v-model="reservationDate"></datepicker>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-select
                    :items="times"
                    label="Время"
                    v-model="reservationInfo.timeVisit"
                    :error-messages="errors['timeVisit'] || []"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field label="Кол-го гостей"
                                :error-messages="errors['countPerson'] || []"
                                v-model="reservationInfo.countPerson" type="number" required>

                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-select
                    :items="times"
                    label="Длительность"
                    v-model="reservationInfo.duration"
                    :error-messages="errors['duration'] || []"
                  ></v-select>
                </v-col>

                <v-col cols="12" class="d-flex justify-space-around">
                  <v-btn class="ma-2" tile color="blue-grey" @click="reservate()" :loading="loading" dark>
                    Зарезервировать
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
    <v-alert type="error" v-if="errors['table' || false]">
      Небходимо выбрать стол для брони
    </v-alert>
    <v-row justify="center" v-if="isMobile">
      <v-col>
        <div class="text-center">

          <v-btn
            v-for="zone in zones"
            :key="zone.id"
            class="ma-2"
            color="blue-grey"
            :color="selectedZones.indexOf(zone.id) !== -1 ? 'indigo' : 'primary'" @click="setZone(zone.id)"
          >
            {{zone.title}}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-card  style="position: absolute;overflow: auto;height: 100%;width: 100%;background-color: #eeeeee" fluid>
        <app-map ref="map" v-if="tables"
                 :selection-tables="selectionTables"
                 :restaurant-id="restaurantId"
                 :tables-with-reservations="tables"
        ></app-map>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import GuestSearch from "./mixin/GuestSearch";
  import AppMap from "./Map";

  export default {
    props: {
      restaurantId: {
        type: [String, Number]
      },
      reservationId: {
        type: [String, Number]
      }
    },
    mixins: [GuestSearch],
    components: {
      Datepicker, AppMap
    },
    mounted() {
      this.isMobile = window.isMobile;
      if (this.reservationId) {
        this.loadReservation();
      }

      this.$store.dispatch('restaurants/getRestaurant', {
        id: this.restaurantId
      }).then((data) => {
        this.restaurant = data.data
        this.loadReservations();
      });

      this.$store.dispatch('restaurantZones/loadZones', {
        restaurantId: this.restaurantId
      });

      let hourVisit = new Date().getHours();
      let timeVisit = new Date().getMinutes();

      if (timeVisit > 0 && timeVisit < 20) {
        timeVisit = 15;
      }

      if (timeVisit > 20 && timeVisit < 35) {
        timeVisit = 30;
      }

      if (timeVisit > 35 && timeVisit < 50) {
        timeVisit = 45;
      }

      if (timeVisit > 50) {
        timeVisit = '00';
        hourVisit += 1;
      }

      this.reservationInfo.timeVisit = hourVisit + ':' + timeVisit
    },
    data() {
      return {
        isMobile : false,
        loading: false,
        selectedZones:[],
        selectionTables: [],
        errors: [],
        reservations: [],
        reservationDate: new Date(),
        disabledDates: {
          to: new Date(Date.now() - 24 *  60 * 60), //
        },
        picker: null,
        availableVisitTimes: ['00:00', "00:15", "00:30", "00:45"],
        selectDateVisit: false,
        reservationInfo: {
          dateVisit: this.getDateInFormat(new Date()),
          timeVisit: null,
          duration: '02:00',
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          notes: '',
          countPerson: 4
        },
        restaurant: null,
        tables: null,
      }
    },
    computed: {
      zones() {
        return this.$store.getters['restaurantZones/getZones']
      },
      times() {
        let time;
        let quarterHours = ["00", "15", "30", "45"];
        let times = [];
        for (let i = 0; i < 24; i++) {
          for (let j = 0; j < 4; j++) {
            time = i;
            if (i <= 9) {
              time = '0' + time;
            }
            times.push(time + ":" + quarterHours[j]);
          }
        }
        return times
      }
    },
    watch: {
      'reservationInfo.dateVisit': {
        handler() {
          this.loadReservations();
        }
      },
      reservationDate() {
        this.reservationInfo.dateVisit = this.getDateInFormat(this.reservationDate)
      }
    },
    methods: {
      setZone(id){
        if(this.selectedZones.indexOf(id) !== -1){
          this.selectedZones.splice(this.selectedZones.indexOf(id), 1);
        }else{
          this.selectedZones.push(id);
        }

        if(this.selectedZones.length > 2){
          this.selectedZones.shift();
        }
        this.$refs.map.filterByZone(this.selectedZones)
      },
      loadReservations() {
        let data = this.reservationInfo;
        let visitDatetime = this.reservationInfo.dateVisit + " " + this.reservationInfo.timeVisit;
        data.selectionTables = this.selectionTables;

        if (data.dateVisit && data.timeVisit && data.duration) {
          axios.post('/reservation/' + this.restaurantId + '/get-all-reservation-for-date', {
            dateTimeVisit: visitDatetime,
          })
            .then(({data}) => {
              this.tables = data;
            })
        }
      },
      loadReservation() {
        axios.get('reservation/' + this.restaurantId + '/' + this.reservationId)
          .then(({data}) => {
            let reservation = data.data;
            this.reservationInfo.id = reservation.id;
            this.reservationInfo.firstName = reservation.guest.first_name;
            this.reservationInfo.lastName = reservation.guest.last_name;
            this.reservationInfo.email = reservation.guest.email;
            this.reservationInfo.phone = reservation.guest.phone;
            this.reservationInfo.countPerson = reservation.count_person;
            this.reservationInfo.duration = reservation.duration;
            this.reservationInfo.timeVisit = reservation.time_visit;
            this.reservationInfo.notes = reservation.notes;
            this.reservationInfo.dateVisit = reservation.date_visit;
            this.selectDateVisit = new Date(reservation.date_visit.split('-').reverse().join(','))
            this.reservationInfo.exclude = reservation.id

            var tables = [];
            reservation.tables.map((item) => {
              tables.push(parseInt(item.table.id))
            });
            this.selectionTables = tables;

          });
      },
      getDateInFormat(date) {
        const dateTimeFormat = new Intl.DateTimeFormat('ru', {year: 'numeric', month: '2-digit', day: '2-digit'})
        const [{value: month}, , {value: day}, , {value: year}] = dateTimeFormat.formatToParts(date)
        return `${month}-${day}-${year}`;
      },
      debounced: _.debounce((cb) => {
        cb()
      }, 700),

      resetForm() {
        this.selectionTables = [];
        this.reservationInfo.firstName = '';
        this.reservationInfo.lastName = '';
        this.reservationInfo.phone = '';
        this.reservationInfo.email = '';
        this.reservationInfo.notes = '';
        this.reservationInfo.dateVisit = this.getDateInFormat(new Date())
      },
      reservate() {

        if (this.loading) {
          return;
        }

        this.errors = [];
        this.loading = true;
        bus.$emit('onProgressLinear');
        let data = this.reservationInfo;
        data.table = this.$refs.map.selectTables
        data.dateTimeVisit = data.dateVisit + ' ' + data.timeVisit
        let url = '/reservation/' + this.restaurantId + '/reservation';
        let message = 'Бронь успешно создана';
        if (data.id) {
          url += '/' + data.id;
          message = 'Бронь успешно обновлена';
        }

        axios.post(url, data)
          .then(({data}) => {
            this.loading = false;
            bus.$emit('offProgressLinear');
            bus.$emit('notificationAlert', {
              text: message,
              color: '#3d97f3'
            });
            if (!this.reservationId) {
              this.resetForm()
            }
            this.getFreeTables();
          }).catch(e => {
          this.loading = false;
          bus.$emit('offProgressLinear');
          let response = e.response
          if (response.status == 422) {
            this.errors = response.data.errors;
          }
          bus.$emit('notificationAlert', {
            text: 'Возникли ошибки',
            color: '#e35351'
          });
        })
      },
      openPicker() {
        this.$refs.programaticOpen.showCalendar();
      }
    }
  }
</script>

<style>
  .vdp-datepicker input {
    display: none;
  }
</style>

